/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import styled, { css } from 'styled-components';
import { space, layout, flexbox, SpaceProps, LayoutProps, FlexboxProps } from 'styled-system';
import { LabelBold } from '../typography/typography';

export const Label = styled(LabelBold)`
	white-space: nowrap;
	color: var(--pill-label-color, rgba(var(--font-dark), 1));
`;

const Wrapper = styled.div<{ isActive?: boolean }>`
	height: 36px;
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 12px;
	border-radius: 26px;
	transition: background-color 0.15s ease-out;
	background-color: var(--pill-bg, rgba(var(--primary), 1));

	${({ isActive }) =>
		isActive &&
		css`
			background-color: var(--pill-checked-bg, rgba(var(--primary), 1));
			${isActive && `border: var(--sportsbook-navigation-pill-border);`};

			${Label} {
				color: var(--pill-checked-label-color, rgba(var(--primary), 1));
			}
		`}
	${space}
	${layout}
	${flexbox}
`;

interface Props extends SpaceProps, LayoutProps, FlexboxProps {
	label?: string;
	id?: string;
	className?: string;
	isActive?: boolean;
	children?: React.ReactNode | React.ReactNode[];
}

/**
 * Pill component without any logic. Should be used with interactive component like button/checkbox/link.
 * @param {string} label - label of the pill
 * @param {string} id - id of the pill
 * @param {string} className - class name of the pill
 * @param {boolean} isActive - is pill active
 * @param {React.ReactNode | React.ReactNode[]} children - children of the pill
 */
const Pill: React.FC<Props> = ({ label, id, className, isActive, children, ...rest }) => {
	return (
		<Wrapper id={id} className={className} isActive={isActive} {...rest}>
			{children || <Label>{label}</Label>}
		</Wrapper>
	);
};

export { Label as PillLabel };
export default Pill;
